import { render, staticRenderFns } from "./RevokeConsentRequestFormComponent.vue?vue&type=template&id=619d09e6"
import script from "./RevokeConsentRequestFormComponent.vue?vue&type=script&lang=js"
export * from "./RevokeConsentRequestFormComponent.vue?vue&type=script&lang=js"
import style0 from "./RevokeConsentRequestFormComponent.vue?vue&type=style&index=0&id=619d09e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports